import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-modal-loader',
    templateUrl: './modal-loader.component.html',
    styleUrls: ['./modal-loader.component.scss'],
})
export class ModalLoaderComponent {

    constructor(
        private modalController: ModalController
    ) {}

    async fechar(opcao) {
        await this.modalController.dismiss(opcao);
    }
}
